'use strict';
angular.module('cvsApp').factory('modifyFormOfPaymentModel', ['commonModel',function(CM) {	
	
	var modifyFormOfPaymentModel = function(){
		
		var self = this;

		self.apiResponse = {};
		
		this.setResponse = function(data){
			// CM.setResponse(data);	
			// self.apiResponse = data;	
			self.apiResponse = cvsUtility.xmlToJSON(data);	
		}	

		this.getResponse = function(data){
			// self.apiResponse = CM.getResponse();	
			self.getError();
			return self;
		}	

		this.showView = function(){
			if(self.apiResponse.isViewError){	
				return !self.apiResponse.isViewError;
			}
			return true;
		}

		// this.getError = function(){
		// 	if(self.apiResponse.showError){	
		// 		return self.apiResponse.showError;
		// 	}
		// 	return "";
		// }
		this.getError = function(){
			if (self.apiResponse.hasOwnProperty("modifyFormOfPaymentResponse") && self.apiResponse.modifyFormOfPaymentResponse.header.statusCode !="0000"){
				self.apiResponse.showError = self.getHeader();
				return self.apiResponse.showError;
            }
			else if (self.apiResponse.hasOwnProperty("response") && self.apiResponse.response.header.statusCode != "0000"){
				self.apiResponse.showError = self.apiResponse.response.header;
				return self.apiResponse.showError;
            }
            return "";
        }

		this.getHeader = function () {
			if (self.apiResponse.hasOwnProperty("modifyFormOfPaymentResponse")){
				return self.apiResponse.modifyFormOfPaymentResponse.header;
            }
			else if (self.apiResponse.hasOwnProperty("response")){
				return self.apiResponse.response.header;
            }
        }

		this.getSuccess =function (){			
			if(!self.apiResponse.showError)			
				return true;			
		}
	
	}
	
	return new modifyFormOfPaymentModel();
}]);